import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { action, computed, observable } from 'mobx';
import { task } from 'mobx-task';
import { required, validationContext } from 'validx';
import { extractMessageFromError } from '../utils/errorUtil';
var AddTeamMemberState = (_dec = action.bound, _dec2 = action.bound, _dec3 = task.resolved, _dec4 = action.bound, _class = /*#__PURE__*/function () {
  function AddTeamMemberState(_ref) {
    var invitationStore = _ref.invitationStore,
      teamRoleStore = _ref.teamRoleStore,
      flashMessageStore = _ref.flashMessageStore,
      team = _ref.team,
      teamMemberStore = _ref.teamMemberStore;
    _classCallCheck(this, AddTeamMemberState);
    _initializerDefineProperty(this, "showing", _descriptor, this);
    _initializerDefineProperty(this, "email", _descriptor2, this);
    _initializerDefineProperty(this, "family_name", _descriptor3, this);
    _initializerDefineProperty(this, "given_name", _descriptor4, this);
    _initializerDefineProperty(this, "phone", _descriptor5, this);
    _initializerDefineProperty(this, "teamRoleId", _descriptor6, this);
    this.validation = validationContext(this, {
      family_name: [required()],
      given_name: [required()],
      phone: [required()],
      email: [required()]
    });
    this.invitationStore = invitationStore;
    this.teamRoleStore = teamRoleStore;
    this.flashMessageStore = flashMessageStore;
    this.team = team;
    this.teamMemberStore = teamMemberStore;
    this.addTeamMember = this.addTeamMember.bind(this);
  }
  return _createClass(AddTeamMemberState, [{
    key: "teamRoles",
    get: function get() {
      return this.teamRoleStore.forWorkspace(this.team.workspaceId).filter(function (role) {
        return !role.isOwnerRole;
      });
    }
  }, {
    key: "currentTeamMemberEmailAddresses",
    get: function get() {
      return new Set(this.teamMemberStore.forTeam(this.team.id).map(function (_ref2) {
        var member = _ref2.member;
        return member.email;
      }));
    }
  }, {
    key: "show",
    value: function show() {
      this.validation.reset();
      this.showing = true;
      this.email = '';
      this.family_name = '';
      this.given_name = '';
      this.phone = '';
      this.activate();
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var role;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.teamRoleStore.fetchTeamRolesForWorkspace(this.team.workspaceId);
            case 2:
              role = this.teamRoles[0];
              this.teamRoleId = role && role.id;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "validate",
    value: function validate() {
      return this.validation.reset().validate().isValid;
    }
  }, {
    key: "addTeamMember",
    value: function () {
      var _addTeamMember = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var msg;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.validate()) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              msg = this.flashMessageStore.create({
                inProgress: true,
                message: 'Adding Team Member'
              });
              return _context2.abrupt("return", this.teamMemberStore.addTeamMember({
                workspace_id: this.team.workspaceId,
                team_id: this.team.id,
                team_role_id: this.teamRoleId,
                email: this.email,
                family_name: this.family_name,
                given_name: this.given_name,
                phone: this.phone
              }).then(function (data) {
                msg.set({
                  message: 'Team Member added'
                }).autoDismiss();
                _this.close();
              }).catch(function (err) {
                msg.set({
                  message: extractMessageFromError(err),
                  type: 'error'
                });
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function addTeamMember() {
        return _addTeamMember.apply(this, arguments);
      }
      return addTeamMember;
    }()
  }, {
    key: "close",
    value: function close() {
      this.showing = false;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "family_name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "given_name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "phone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "teamRoleId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "teamRoles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamRoles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTeamMemberEmailAddresses", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTeamMemberEmailAddresses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "show", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validate", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addTeamMember", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "addTeamMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _class);
export { AddTeamMemberState as default };
//# sourceMappingURL=AddTeamMemberState.js.map
